module.exports = __webpack_public_path__ + "static/footer-mobile-2763e8cdbe02f6dd0fbdfda3da51cd10.svg";